<mat-grid-list cols="{{ dimensions }}" rowHeight="{{ blocUnit }}">
  <mat-grid-tile
    *ngFor="let tile of tiles"
    [colspan]="1"
    [rowspan]="1"
    [ngStyle]="{
      background: tile.color,
      transform: 'scale(' + tile.filled + ')'
    }"
  >
  </mat-grid-tile>
</mat-grid-list>
